import { createWithEqualityFn } from 'zustand/traditional';

export type EditFieldEntryPoint = 'Field List' | 'Map';

export interface EditFieldTarget {
  organizationId: string;
  propertyId: string;
  fieldId: string;
  entryPoint: EditFieldEntryPoint;
}

interface EditFieldState {
  editing: EditFieldTarget | null;
  // Set on the first open, so the fields/edit remote (~9 MB) only loads once someone edits a field.
  hasOpened: boolean;
  // Set when the remote fails to load. React.lazy keeps the rejection for the whole session, so
  // later edits go straight to the Farm Settings deep action.
  isMfeUnavailable: boolean;
}

interface EditFieldActions {
  openEditField: (target: EditFieldTarget) => void;
  closeEditField: () => void;
  markMfeUnavailable: () => void;
  reset: () => void;
}

const initialState: EditFieldState = {
  editing: null,
  hasOpened: false,
  isMfeUnavailable: false,
};

export const editFieldStore = createWithEqualityFn<EditFieldState & EditFieldActions>((set) => ({
  ...initialState,
  openEditField: (target) => {
    set(() => ({ editing: target, hasOpened: true }));
  },
  closeEditField: () => {
    set(() => ({ editing: null }));
  },
  markMfeUnavailable: () => {
    set(() => ({ editing: null, isMfeUnavailable: true }));
  },
  reset: () => {
    set(() => initialState);
  },
}));
